<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>考试名称：</p>
          <input type="text" placeholder="请输入考试名称" v-model="obj.title">
        </div>
        <div class="search-item">
          <p>发布状态：</p>
          <select v-model="obj.status">
            <option :value="item.id" v-for="item in statusList" v-bind:key="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>考试列表</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addShow">添加考试</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.mtid">{{item.mtid}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.publish_status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p style="color:#FF7543;">
                  <span @click="topicSub(item)">题库包</span>
                  <span @click="lookStudent(item)">查看学员</span>
                  <span @click="editShow(item)">编辑</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">{{showType=='add'?'添加类型':'编辑类型'}}</p>
        <form>
          <div class="write-txt">
            <p>考试名称：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>考试类型：</p>
            <select v-model="addObj.mtsid">
              <option value="">请选择</option>
              <option :value="item.id" v-for="(item,index) in examList" :key="(index+1)">{{item.name}}</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getMockTestList,saveMockTest,getSelectMockTestSetList,publishMockTest } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'考试ID'},
        {id:3,title:'考试名称'},
        {id:4,title:'创建时间'},
        {id:5,title:'发布状态'},
        {id:6,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        page:1,
        rows:10,
        status:9
      },
      addObj:{
        mtsid:'',
        name:''
      },
      totalPage:0,
      userData:{
        authority:[],
      },
      statusList:[
        {id:9,title:'全部'},
        {id:1,title:'开启'},
        {id:0,title:'未开启'},
      ],
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.getList();
    this.getExamList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    // 取消
    closeSub(){
      this.addObj.name = '';
      this.showType = '';
    },

    // 确认添加or编辑
    addSub(){
      var that = this;
      console.log(this.addObj,'==ree==')
      saveMockTest(that.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      this.obj.page = 1;
      if(this.obj.title){
        delete this.obj.title;
      };
      this.addObj={
        mtsid:'',
        name:''
      };
      this.dataList = [];
      this.getList();
    },

    getList(){
      var that = this;
      getMockTestList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.dataList.forEach(function(item,index){
            if(item.publish_status == 0){
              item.publish_status = false;
            } else {
              item.publish_status = true;
            }
          });
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.showType = 'add';
      this.addObj.name = '';
    },

    editShow(e){
      this.showType = 'edit';
      this.addObj.mtid = e.mtid;
      this.addObj.name = e.name;
      console.log(this.addObj)
    },

    getExamList(){
      var that = this;
      getSelectMockTestSetList(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.examList = data.data;
        } else {
          that.$message(data.msg);
        }
      })
    },

    switchChange(e){
      var that = this;
      var obj = {
        mtid:e.mtid,
        status:e.publish_status==false?0:1,
      };
      publishMockTest(obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('发布状态修改成功！');
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },

    topicSub(e){
      var that = this;
      console.log(e.mtid)
      that.$router.push('/pack?id='+e.mtid);
    },

    lookStudent(e){
      var that = this;
      that.$router.push('/parent');
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 6 );
}


</style>



// WEBPACK FOOTER //
// src/exam/list.vue